import { authComputed, merchantComputed } from '@store/helpers'
import { messageSuccess } from "@utils/message"
import { storeOptions } from "@utils/ipetbooking-options";
import { termsMenuList } from "@src/config/menu";
import isCondition from "@utils/is-condition";
import liff from "@line/liff";
import lineGetProfileAndLogin from "@utils/line-get-profile-and-login";
import configSSO from "@src/config/sso";

export default {
  data() {
    return {
      termsMenuList: Object.freeze(termsMenuList()),
      storeOpenOptions: Object.freeze(storeOptions({
        type: 'open'
      })),
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
  },
  methods: {
    isCondition,
    goToLogin() {
      if(liff.isInClient() && this.isLiffInit) {
        lineGetProfileAndLogin({
          liffId: this.currentLiffId,
          callBack: () => {
            messageSuccess({
              title: '驗證成功',
              content: '您已成功登入。',
            });
          },
        })
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            /* const shouldOpenDialogLineNotify = () => {
              const isBound = this.currentMember?.lineInfo.isBindLineNotify
              const invisibleDialog = this.$store.state.auth.currentInvisibleDialogLineNotify
              return !isBound && !invisibleDialog
            }
            const urlQuery = shouldOpenDialogLineNotify() ? '?dialogDialogLineNotifyVisible=true' : ''

            messageSuccess({
              title: '驗證成功',
              content: '您已成功登入。',
            });

            if (this.$globalIsJtailsMode) {
              const isMockApi = this.$apiPath.indexOf('mock') !== -1;
              if (!isMockApi && configSSO.enabled) {
                this.$store.dispatch('auth/wordpressLogIn', `${window.location.origin}/member${urlQuery}`);
              } else {
                this.$nextTick(() => {
                  this.$router.push({
                    name: 'member'
                  })
                })
              }
            } else {
              this.$nextTick(() => {
                this.$router.push({
                  name: 'member'
                })
              })
            } */
          }
        })
      }
    },
    goToMember() {
      this.$router.push({
        name: 'member'
      })
    },
    goToPrepaidReservation() {
      const loggedInFn = () => {
        this.goToAndCloseMenu({
          name: 'prepaid-reservation'
        })
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn();
          }
        });
      }
    },
    goToLink(e, to) {
      e.preventDefault();
      const loggedInFn = () => {
        this.goToAndCloseMenu(to)
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn();
          }
        });
      }
    },
    openMenu() {
      this.$globalHambugerOpen = !this.$globalHambugerOpen
    },
    goToAndCloseMenu(to) {
      this.$router.push(to);
      this.$globalHambugerOpen = false;
    },
    openDialogLine() {
      if(this.$globalIsMobileDevice && this.currentMerchant.lineFriendUrl) {
        window.open(this.currentMerchant.lineFriendUrl)
      } else {
        this.$globalDialog('DialogLine', {
          lineId: this.currentMerchant.lineId,
          lineFriendUrl: this.currentMerchant.lineFriendUrl
        });
      }
    },
  }
}
